import { useQuery } from 'react-query';
import { getEducationMaterials } from '../../educationMaterials';
import QueryKeys from '../queryKeys';
import { OrganizationQueryParams } from 'interfaces/queryParams';
import { IQueryRequest } from 'interfaces/request';

const useEducationMaterials = ({
  params,
  options,
}: IQueryRequest<OrganizationQueryParams>) => {
  return useQuery({
    ...options,
    queryFn: async () => {
      const { data } = await getEducationMaterials(params.organizationId);
      return data.data;
    },
    queryKey: [QueryKeys.getEducationMaterials, params.organizationId],
  });
};

export default useEducationMaterials;
